import { RendleyStore } from "../../../../store/RendleyStore";
import { Engine } from "@rendley/sdk";
import { ApplicationStore } from "../../../../store/ApplicationStore";
import { TransitionService } from "../../services/TransitionService";

interface useCreateTransitionOnDropOptions {
  transitionId: string;
  clipId: string;
  layerId: string;
}

function useCreateTransitionOnDrop() {
  return async (options: useCreateTransitionOnDropOptions) => {
    const { transitionId, clipId, layerId } = options;

    let startClipId: string | null = null;
    const endClipId: string | null = clipId;

    const clips = RendleyStore.layers[layerId].clipsIds;
    const endClipIndex = clips.findIndex((cv) => cv === endClipId);

    if (endClipIndex < 0) {
      return null;
    }

    startClipId = clips[endClipIndex - 1];

    const transition = ApplicationStore.transitions[transitionId];
    const shaderSrc = await TransitionService.getTransitionShader(transition.shaderUrl);

    if (shaderSrc == null) {
      return null;
    }

    const library = Engine.getInstance().getLibrary();
    const libraryTransition = library.transitions[transition.id];

    let libraryTransitionId: string;

    if (libraryTransition != null) {
      libraryTransitionId = libraryTransition.getId();
    } else {
      libraryTransitionId = await library.addTransition({
        id: transition.id,
        name: transition.label,
        transitionSrc: shaderSrc,
        serializable: false,
        properties: transition.properties,
      });
    }

    const layer = Engine.getInstance().getTimeline().getLayerById(layerId);

    if (layer == null) {
      return null;
    }

    layer.addTransition({
      startClipId,
      endClipId,
      inDuration: 1,
      outDuration: 1,
      transitionId: libraryTransitionId,
    });
  };
}

export { useCreateTransitionOnDrop };
